import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ScaleNormalizer from "./Components/ScaleNormalizer";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import { BrowserRouter as Router } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  
  <React.StrictMode>
    <Router>
      <Suspense fallback={<div className="page-loader">Loading...</div>}>
        <ScaleNormalizer scaleFactor={1}>
          <Header />
        </ScaleNormalizer>
        <ScaleNormalizer scaleFactor={1}>
            <App />
            <Footer />
        </ScaleNormalizer>
      </Suspense>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
